module.exports = __webpack_public_path__ + "img/settlement@2x.6e3bba1e.png";